import { render, staticRenderFns } from "./User_edit.vue?vue&type=template&id=e547c504"
import script from "./User_edit.vue?vue&type=script&lang=js"
export * from "./User_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports